import * as React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { fetchOrgAccessData, updateOrgAccesssData } from '../actions/action';
import Icon from '../../../icons';

//Component Imports

class OrgAccess extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            accessToOrgIds: []
        }
        this.selectOrgHandler = this.selectOrgHandler.bind(this);
        this.submitHandler = this.submitHandler.bind(this);
    }

    componentWillReceiveProps(newProps) {
        if (newProps.accessToOrgIds && newProps.accessToOrgIds.length > 0 && JSON.stringify(this.state.accessToOrgIds) != JSON.stringify(newProps.accessToOrgIds)) {
            this.setState({
                accessToOrgIds: newProps.accessToOrgIds
            })
        }
    }

    componentDidMount() {
        this.props.fetchOrgAccessData();
    }

    selectOrgHandler = (event, id) => {
        let selectedOrgIds = this.state.accessToOrgIds;
        if (!this.state.accessToOrgIds.includes(id)) {
            selectedOrgIds.push(id)
        } else {
            const index = selectedOrgIds.indexOf(id);
            if (index > -1) {
                selectedOrgIds.splice(index, 1);
            }
        }
        this.setState({
            accessToOrgIds: selectedOrgIds
        })
    }

    submitHandler = () => {
        const { accessToOrgIds } = this.state;
        const orglist = accessToOrgIds.map((item) => item)
        const payload = {
            accessedOrgIds: orglist
        }
        this.props.updateOrgAccesssData(payload);
        $("#orgAccessPanelShow").removeClass("active");
        this.props.onClose();
    }

    render() {
        const { orgs } = this.props;
        let selectedOrgIds = this.state.accessToOrgIds;
        return (
            <div className="orgAccess">
                <header className="alignMiddle pdl__1 pdr__1">
                    <span className="flexGrow flexWrap"><h2>Organization Access</h2></span>
                    <a className="h__16 ml__1" href="javascript:void(0)" onClick={this.props.onClose}><Icon name="close" className="icon" /></a>
                </header>
                <p className="ml__1 mr__1 helpText">Select below organizations to access their Workkards and Activities along with your own.</p>

                <ul className="colFlex">
                    {
                        orgs && orgs.map((org) => (
                            <li key={org.Id} onClick={(e) => this.selectOrgHandler(e, org.Id)}>
                                <div className="userGroup rowFlex">
                                    <div className="userPic userPicIcon">
                                        <img className="" src={org.ProfileFullImage} />
                                        {(this.state.accessToOrgIds.length > 0 && this.state.accessToOrgIds.includes(org.Id)) && 
                                        <span className='badges profileChecked green'></span>}
                                    </div>
                                    <div className="userInfo"><label>{org.OrganizationName}</label></div>
                                </div>
                            </li>
                        ))
                    }                
                </ul>
                <footer className="rowFlex alignRight">
                    <button className="btn buttonGradient" onClick={this.submitHandler}>Apply</button>
                </footer>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    orgs: state.header.orgAccess.orgViews,
    accessToOrgIds: state.sessionContext.AccessToOrgIds,
});

const mapDispatchToProps = (dispatch) => ({
    fetchOrgAccessData: bindActionCreators(fetchOrgAccessData, dispatch),
    updateOrgAccesssData: bindActionCreators(updateOrgAccesssData, dispatch),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(OrgAccess);
